import { Container, Row } from "reactstrap";
import TableChildPackage from "../Table/TableChildPackage";

function PackageTable({ data, handleClick }) {
    return (
        <>
        <Container className="landing-package-container">
            <Row className="g-4 justify-content-center">
            {data.map((pkg) => (
                <TableChildPackage
                    key={pkg.id}
                    pkg = {pkg}
                    handleClick = {handleClick}
                />
            ))}
            </Row>
        </Container>
        </>
    );
}

export default PackageTable;
